export const staticProjectIdsSC = '41';

export const person = 'ท่าน';



// WEBPACK FOOTER //
// ./src/components/other-web/Conference/Presenters/Static.js